const l = {
  name: "Integration",
  dimensions: { width: 39, height: 39 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.4 39.4" style="enable-background:new 0 0 39.4 39.4;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M32.7,8.1c2.8,3.5,2.6,8.7-0.7,12l-3.7,3.7L15.6,11l3.7-3.7c3.3-3.3,8.4-3.5,12-0.7L38,0l1.4,1.4L32.7,8.1z
			 M18.5,11l9.9,9.9l2.3-2.3c2.7-2.7,2.7-7.2,0-9.9c-2.7-2.7-7.2-2.7-9.9,0L18.5,11z"/>
		<path class="st0" d="M23.8,28.4l-2.7-2.7l3.3-3.3L23,21l-3.3,3.3l-4.6-4.6l3.3-3.3L17,15l-3.3,3.3L11,15.6l-3.7,3.7
			c-3.3,3.3-3.5,8.4-0.7,12L0,38l1.4,1.4l6.7-6.7c3.5,2.8,8.7,2.6,12-0.7L23.8,28.4z M8.8,20.8l2.3-2.3l9.9,9.9l-2.3,2.3
			c-2.7,2.7-7.2,2.7-9.9,0C6,27.9,6,23.5,8.8,20.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Integration
};
